<template>
  <Timeline :style="{backgroundColor: '#fff'}">
    <TimelineItem :style="{padding: '15px'}" :color="item.color" v-for="item in logs_own" :key="item.id">
      <p class="time">{{ item.datetime_format }}</p>
      <b>结果：</b><pre class="code-con">{{ item.result_json }}</pre>
      <p><b>操作人：</b>{{ item.user_full_name }}</p>
    </TimelineItem>
  </Timeline>
</template>
<script>
export default {
  name: 'script-exec-logs',
  props: ['logs'],
  data () {
    return {
      logs_own: this.logs
    }
  },
  watch: {
    logs () {
      let logsTmp = []
      this.logs.map((item, index) => {
        if (item.type === 'error') {
          item['color'] = 'red'
        } else {
          item['color'] = 'green'
        }
        logsTmp.push(item)
      })
      this.logs_own = logsTmp
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>
<style>
  .time{
    font-size: 14px;
    font-weight: bold;
  }
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .code-con{
    background: #F9F9F9;
  }
</style>
